<script setup>
import { ref, computed } from 'vue'
import OrganisationList from '@/Components/Models/Organisation/List.vue'
import RelationshipRoleSelector from '@/Components/Models/User/Roles/RelationshipRoleSelector.vue'

const props = defineProps({
	user: {
		type: Object,
		required: true,
	},
	organisation: {
		type: Object,
		required: false,
	},
	roles: {
		type: Array,
		required: true,
	},
	errors: {
		type: Object,
		default: () => {},
	},
})

const emit = defineEmits([
	'change-organisation',
	'set-permissions'
])

const selectedRole = computed(() => {
	return props.user.permissions?.organisations?.find(org => org.id === props.organisation.id)?.role.name
})

const selectOrganisation = (organisation) => {
	emit('change-organisation', organisation)
}

const selectRole = (role) => {
	if( !role ) {
		emit('set-permissions', [])
		return
	}
	// else
	emit('set-permissions', {
		organisations: [
			{
				id: props.organisation.id,
				role: role
			}
		]
	});
}

</script>

<template>
	<div class="set-user-organisation-permissions">
		<div v-if="!organisation">
			<Alert type="warning">
				<template #default>
					<p class="text-sm">
						You must select an organisation before you can set permissions.
					</p>
				</template>
			</Alert>
			
			<OrganisationList 
				:items="organisations" 
				@item-clicked="selectOrganisation"
				:fetch-on-mount="true"
			/>
		</div>

		<div v-if="!!organisation">
			<RelationshipRoleSelector 
				:currentRole='selectedRole'
				relationship="organisations"
				:roles="roles"
				@role-selected="selectRole"
				:errors="errors"
			/>
		</div>
	</div>
</template>